module.exports = __webpack_public_path__ + "img/amgen.53250162.png";